import { IModelEntity } from '@pit/core';

export interface IDtoMandator extends IModelEntity {

    code?: string;
    codeInternal?: string;
    description?: string;
    name1?: string;
    name2?: string;
    numberMandator?: string;
    useLDAP?: boolean;

    fullDescription?: string;
    fullName?: string;

}
